import React, { useEffect, useState } from 'react';
import { FormDisplay } from './MFormPage.model';
import MFormPageView from './MFormPage.view';

type Props = {
  header?: JSX.Element;
  formJSX: JSX.Element | null;
  // TODO: Remove FormDisplay which is unncessary now that everything is on side view
  open?: FormDisplay | null;
  className?: string;
  classNameChildrenContent?: string;
  title?: string | null;
  subTitle?: string | null;
  isFullScreen?: boolean;
  wideOpen?: boolean;
  onFormOpenEnd?: () => void;
  onFormCloseEnd?: () => void;
};

const MFormPage: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [formJSXState, setFormJSXState] = useState<JSX.Element | null>(props.formJSX);

  useEffect(() => {
    setFormJSXState((prev: JSX.Element | null) => {
      if (prev && props.formJSX) {
        setFormJSXState(() => props.formJSX);
      }

      return prev;
    });
  }, [props.formJSX]);

  const closeForm = () => {
    setFormJSXState(() => null);
    props.onFormCloseEnd?.();
  };

  return (
    <MFormPageView
      wideOpen={props.wideOpen}
      header={props.header}
      className={props.className}
      classNameChildrenContent={props.classNameChildrenContent}
      formJSX={formJSXState}
      open={props.open}
      isFullScreen={props.isFullScreen}
      onFormOpenStart={() => setFormJSXState(() => props.formJSX)}
      onFormCloseEnd={closeForm}
      onFormOpenEnd={props.onFormOpenEnd}
    >
      {props.children}
    </MFormPageView>
  );
};

MFormPage.displayName = 'MFormPage';
MFormPage.defaultProps = {};

export default MFormPage;
